import axios from "axios";

class News
{
    constructor() {
        
    }

    async readGen4(id)
    {
        const apiBase = process.env.REACT_APP_API_BASE_URL
        const response = await axios.get(apiBase + "v1/news-gen4/" + id)
        if(response.data.success) {
            return response.data.data;
        } else {
            throw new Error(response.data.message);
        }
    }
}

export default News
